export default "__VITE_ASSET__a511422a__"